var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.857,
    height: 10.857,
    viewBox: "0 0 10.857 10.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_candle-2",
    "data-name": "vuesax/outline/candle-2",
    transform: "translate(-428 -254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "candle-2",
    transform: "translate(428 254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.506.679H.339A.342.342,0,0,1,0,.339.342.342,0,0,1,.339,0H3.506a.342.342,0,0,1,.339.339A.342.342,0,0,1,3.506.679Z",
    transform: "translate(6.447 7.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.7.679H.339A.342.342,0,0,1,0,.339.342.342,0,0,1,.339,0H1.7a.342.342,0,0,1,.339.339A.342.342,0,0,1,1.7.679Z",
    transform: "translate(0.565 7.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.7.679H.339A.342.342,0,0,1,0,.339.342.342,0,0,1,.339,0H1.7a.342.342,0,0,1,.339.339A.342.342,0,0,1,1.7.679Z",
    transform: "translate(8.256 2.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.506.679H.339A.342.342,0,0,1,0,.339.342.342,0,0,1,.339,0H3.506a.342.342,0,0,1,.339.339A.342.342,0,0,1,3.506.679Z",
    transform: "translate(0.565 2.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3.958,3.393H1.244A1.144,1.144,0,0,1,0,2.149v-.9A1.144,1.144,0,0,1,1.244,0H3.958A1.144,1.144,0,0,1,5.2,1.244v.9A1.144,1.144,0,0,1,3.958,3.393ZM1.244.679c-.4,0-.565.163-.565.565v.9c0,.4.163.565.565.565H3.958c.4,0,.565-.163.565-.565v-.9c0-.4-.163-.565-.565-.565Z",
    transform: "translate(1.923 6.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M3.958,3.393H1.244A1.144,1.144,0,0,1,0,2.149v-.9A1.144,1.144,0,0,1,1.244,0H3.958A1.144,1.144,0,0,1,5.2,1.244v.9A1.144,1.144,0,0,1,3.958,3.393ZM1.244.679c-.4,0-.565.163-.565.565v.9c0,.4.163.565.565.565H3.958c.4,0,.565-.163.565-.565v-.9c0-.4-.163-.565-.565-.565Z",
    transform: "translate(3.732 1.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H10.857V10.857H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d4c3e3aeafc3248a84ead519e6b61d74.svg";
export { ForwardRef as ReactComponent };